export const quotesBullSayBearSayRoutes = {
  statements: {
    proxy: 'quotes/bull-bear',
    upstream: 'api/v1/bulls_bears_say',
  },
} as const;
